export default __webpack_public_path__ + "static/textAndImages_cloud_top-959738300fad4252c033c41c53eed590.webp";